import { render, staticRenderFns } from "./DirectMessage.vue?vue&type=template&id=62c2d531&scoped=true&"
import script from "./DirectMessage.vue?vue&type=script&lang=js&"
export * from "./DirectMessage.vue?vue&type=script&lang=js&"
import style0 from "./DirectMessage.vue?vue&type=style&index=0&id=62c2d531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2d531",
  null
  
)

export default component.exports